import { getLeftCandidateInfo, getRightCandidateData } from '../../utils';
import { SubHeader } from '../../../styles';
import { ATSPrincipalAppCandidateModalTabsTestIds } from 'data-testids/ATS';
import { Grid, Link, Stack, Typography, useTheme } from '@mui/material';
import { OverviewItemProps } from 'features/Principal/types/modalTypes';

export const OverviewItem: React.FC<OverviewItemProps> = ({ data, onContentClick }) => {
  const theme = useTheme();
  const Icon = data.Icon;
  const hasContent = data.content != null;
  const displayContent = hasContent ? data.content : 'Not provided';

  return (
    <Stack direction="row" sx={{ mb: 2 }}>
      <Icon />
      <Stack data-testid={data.testId} direction="column" sx={{ pl: 1 }}>
        <Typography>{data.headerText.toUpperCase()} &nbsp;</Typography>
        {onContentClick && hasContent ? (
          <Link
            component="button"
            onClick={onContentClick}
            underline="hover"
            sx={{ color: theme.palette.primary.main, textAlign: 'left', p: 0 }}
          >
            {displayContent}
          </Link>
        ) : (
          <Typography sx={{ color: theme.palette.text.primary }}>{displayContent}</Typography>
        )}
      </Stack>
    </Stack>
  );
};

interface CandidateOverviewProps {
  row: Parameters<typeof getLeftCandidateInfo>[0];
  onEmailClick?: () => void;
}

export const CandidateOverview: React.FC<CandidateOverviewProps> = ({ row, onEmailClick }) => {
  const leftColumnData = getLeftCandidateInfo(row);
  const rightColumnData = getRightCandidateData(row);

  return (
    <>
      <SubHeader variant="h3">Candidate Overview</SubHeader>
      <Grid container spacing={1} sx={{ mt: 1 }}>
        <Grid item xs={6}>
          <>
            {leftColumnData?.map((data, index) => {
              const isEmail =
                data.testId === ATSPrincipalAppCandidateModalTabsTestIds.BASIC_INFO_EMAIL;
              return (
                <OverviewItem
                  data={data}
                  key={index}
                  onContentClick={isEmail ? onEmailClick : undefined}
                />
              );
            })}
          </>
        </Grid>
        <Grid item xs={6}>
          <>
            {rightColumnData?.map((data, index) => {
              return <OverviewItem data={data} key={index} />;
            })}
          </>
        </Grid>
      </Grid>
    </>
  );
};
